var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "sidebar-item" }, [_c("job-queued")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [
        _c("div", { staticClass: "agenerate-btn-box", class: {} }, [
          _c(
            "div",
            {
              staticClass: "generate-btn px-20",
              class: { disabled: _vm.isDone === false || this.loading },
              on: { click: _vm.applyImage },
            },
            [
              _vm._v(
                "\n\n        " +
                  _vm._s(_vm._f("trans")("Continue")) +
                  "\n        "
              ),
              !_vm.loading
                ? _c("i", { staticClass: "far fa-arrow-right font-size-150" })
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c("i", { staticClass: "fa fa-spin btn-loading-animation" })
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("export-btn")], 1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sys-container d-flex flex-column align-items-center p-0 m-0",
        },
        [
          this.activeStage.mainJob !== null
            ? _c(
                "div",
                {
                  staticClass: "sidebar-item",
                  class: {
                    "bg-secondary text-white":
                      _vm.image ===
                        this.activeStage.mainJob.apiJob.output[0].uri &&
                      _vm.activeStage.preview === true,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.chooseActiveStage()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-100 d-flex justify-content-between align-items-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex h-100 align-items-center px-3 font-size-125 h-100 align-items-center",
                        },
                        [_vm._v("Original:")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "sys-thumb",
                          class: {
                            active:
                              _vm.image ===
                                this.activeStage.mainJob.apiJob.output[0].uri &&
                              _vm.activeStage.preview === true,
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "sys-img",
                            attrs: {
                              src: _vm.getImageFromStorage(
                                this.activeStage.mainJob.apiJob.output[0].uri
                              ),
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.currentJob.getActiveStageJob().sysJobs, function (sysJob) {
        return _c(
          "div",
          {
            staticClass:
              "sys-container d-flex flex-column align-items-center p-0 m-0",
          },
          _vm._l(sysJob.apiJob.output, function (output) {
            return _c(
              "div",
              {
                staticClass: "sidebar-item",
                class: {
                  "bg-secondary text-white":
                    _vm.image === output.uri &&
                    _vm.activeStage.preview === true,
                },
                on: {
                  click: function ($event) {
                    return _vm.chooseImage(output.uri)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "h-100 d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex h-100 align-items-center px-3 font-size-125 h-100 align-items-center",
                      },
                      [_vm._v("Generated:")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sys-thumb",
                        class: {
                          active:
                            _vm.image === output.uri &&
                            _vm.activeStage.preview === true,
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "sys-img",
                          attrs: { src: _vm.getImageFromStorage(output.uri) },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }